export const messages = {
  title: 'Получите отчет по оценке полей на основе спутниковых данных',
  badges: {
    available: 'Вам доступно до 5 отчетов',
    forAgriLand: {
      full: 'Для земель с/х назначения',
      short: 'Для с/х земель',
    },
  },
  imagesCaption: 'Примеры снимков из отчета',
  benefits: {
    title: 'Что такой отчет даст аграрию?',
    items: [
      'Покажет неиспользуемые площади и потенциал для развития.',
      'Возможность точно планировать посевы, агротехнику, экономить ресурсы.',
      'Позволит обосновать свою позицию при аренде, купле-продаже, страховании.',
      'Поможет избежать штрафов за неточную отчетность.',
    ],
  },
  actions: {
    request: 'Запросить отчет',
    close: 'Закрыть',
  },
  successDialog: {
    title: 'Запрос отправлен!',
    subtitle: 'Наш менеджер свяжется с вами в течение рабочего дня',
    submit: 'Понятно',
  },
  errorDialog: {
    title: 'Что-то пошло не так!',
    subtitle: 'Попробуйте оставить заявку позже',
    submit: 'Понятно',
  },
}
